import * as React from 'react';

{
  /* <path
  fill="#66A1B6"
  d="M218 106c3.442.576 4.996 1.658 7.348 4.203l1.834 1.973 1.88 2.074 1.893 2.027c6.23 6.769 8.502 10.935 8.338 20.18l-.013 2.736c-.017 2.874-.054 5.746-.093 8.62a4118.5 4118.5 0 0 0-.04 5.857c-.034 4.777-.085 9.553-.147 14.33h-15v-3l-1 5-3.618-.04a6058.69 6058.69 0 0 0-33.725-.27c-5.78-.032-11.56-.075-17.34-.143-5.576-.065-11.151-.1-16.728-.116a640.26 640.26 0 0 1-6.387-.065c-2.98-.044-5.956-.05-8.935-.047l-2.677-.066-2.464.025-2.135-.016c-3.428 1.27-4.37 3.566-5.991 6.738-.382 2.89-.549 5.394-.519 8.276l-.023 2.478c-.02 2.732-.012 5.463-.004 8.195a2942.174 2942.174 0 0 0-.062 21.844c-.003 5.56-.028 11.122-.051 16.683-.041 10.53-.061 21.058-.074 31.587-.016 11.988-.055 23.976-.095 35.964-.082 24.657-.136 49.315-.172 73.973H91c-.093-26.8-.164-53.599-.207-80.398-.02-12.444-.049-24.888-.095-37.332-.04-10.849-.065-21.697-.074-32.545-.006-5.742-.018-11.484-.047-17.226-.027-5.41-.035-10.82-.03-16.23 0-1.98-.008-3.96-.024-5.941-.1-13.448.46-24.557 9.5-35.328 7.943-8.037 18.253-12.389 29.478-12.58l3.054.006 3.224-.043c3.365-.042 6.73-.057 10.096-.07 3.387-.03 6.774-.064 10.16-.103 2.1-.022 4.198-.038 6.297-.047l2.875-.021 2.519-.01c2.217-.129 4.131-.585 6.274-1.132 1.343.294 2.676.63 4 1 1.705.138 3.415.22 5.125.25l2.633.078L188 137l2-3-5-2c.375-1.938.375-1.938 1-4 2.525-1.262 4.312-1.099 7.125-1.063l2.758.028L198 127l-1-5h5v-5l2-1v-3c3.108.918 5.569 1.658 8.125 3.688 1.783 1.569 1.783 1.569 3.938 1L218 117h3l-2.063-2.688C217 111 217 111 217.25 108.126L218 106Z"
></path>; */
}

interface WaterPumpProps extends React.SVGProps<SVGSVGElement> {
  running?: boolean;
}

export const WaterPump = ({ running, ...props }: WaterPumpProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 375"
    width="100%"
    height="100%"
    {...props}
  >
    <defs>
      {/* 물 흐름 경로 */}
      <path
        id="waterPath"
        d="M218 106c3.442.576 4.996 1.658 7.348 4.203l1.834 1.973 1.88 2.074 1.893 2.027c6.23 6.769 8.502 10.935 8.338 20.18l-.013 2.736c-.017 2.874-.054 5.746-.093 8.62a4118.5 4118.5 0 0 0-.04 5.857c-.034 4.777-.085 9.553-.147 14.33h-15v-3l-1 5-3.618-.04a6058.69 6058.69 0 0 0-33.725-.27c-5.78-.032-11.56-.075-17.34-.143-5.576-.065-11.151-.1-16.728-.116a640.26 640.26 0 0 1-6.387-.065c-2.98-.044-5.956-.05-8.935-.047l-2.677-.066-2.464.025-2.135-.016c-3.428 1.27-4.37 3.566-5.991 6.738-.382 2.89-.549 5.394-.519 8.276l-.023 2.478c-.02 2.732-.012 5.463-.004 8.195a2942.174 2942.174 0 0 0-.062 21.844c-.003 5.56-.028 11.122-.051 16.683-.041 10.53-.061 21.058-.074 31.587-.016 11.988-.055 23.976-.095 35.964-.082 24.657-.136 49.315-.172 73.973H91"
      />
    </defs>
    <path
      fill="#788BA1"
      d="M249 52h89v16h-29v26h13v16c14.923 1.366 14.923 1.366 28.23-3.89 3.536-3.602 6.508-7.586 8.77-12.11h16V67h62v27l8.454-.063c9.248-.067 18.496-.111 27.744-.144 5.604-.021 11.207-.05 16.811-.095 5.414-.043 10.828-.067 16.242-.078 2.06-.007 4.119-.021 6.178-.043 20.72-.21 20.72-.21 29.571 4.423 1.603 11.224 1 22.662 1 34l57 1v33l-57 1v25c-6.07 7.441-9.489 10.59-18.812 11.81-5.21.392-10.353.157-15.563-.123-1.815-.055-3.63-.105-5.445-.15-4.401-.11-8.778-.325-13.18-.537v33h-22v-33l-9.492.238c-10.397.25-20.794.415-31.193.54-6.3.077-12.597.183-18.895.354a887.21 887.21 0 0 1-18.266.291c-2.313.028-4.626.081-6.937.163-19.15.648-19.15.648-25.836-4.966-2.67-2.58-4.988-5.318-7.29-8.226-2.92-3.59-5.351-4.547-10.025-5.078-2.17.007-4.34.088-6.503.246l-3.409.061c-2.728.058-5.433.184-8.154.377l.035 3.246.027 4.191.026 2.143c.009 1.807-.036 3.614-.088 5.42l-1 1h-12v27h12c1 1 1 1 1.098 3.285l-.036 2.778-.027 2.785L322 241c-7.806.023-15.611.04-23.417.052-3.624.005-7.249.012-10.873.023-3.495.011-6.99.017-10.484.02-1.988.003-3.977.01-5.965.018h-3.64l-3.223.007C262 241 262 241 261 240c-.098-1.497-.13-3-.125-4.5l-.008-2.469C261 231 261 231 262 230c2.02-.072 4.042-.084 6.063-.063l3.347.028L274 230c.13-6.135.186-12.265.177-18.402.007-2.08.033-4.16.08-6.24.232-10.836.273-20.196-6.269-29.26l-1.344-1.87c-2.876-3.436-5.038-4.59-9.518-5.11A90.057 90.057 0 0 0 253 169l.048 2.599c.05 3.19.088 6.38.117 9.571.015 1.38.035 2.759.061 4.138.037 1.986.052 3.972.067 5.958l.048 3.618c-.37 3.387-.963 4.727-3.341 7.116-2.375.938-2.375.938-5 1-2.283-1.142-4.19-2.19-6-4-.088-2.219-.107-4.44-.098-6.66l.005-2.014c.005-2.13.018-4.259.03-6.388A3964.642 3964.642 0 0 1 239 169l-3.158.223c-11.362.746-22.649.844-34.031.7-5.204-.063-10.408-.092-15.612-.128a3330.41 3330.41 0 0 1-19.725-.193c-5.363-.07-10.726-.11-16.09-.132a566.625 566.625 0 0 1-6.103-.074c-2.828-.048-5.655-.059-8.484-.061l-2.534-.07c-2.617-.044-2.617-.044-6.263.735-3.968 4.531-4.579 8.46-4.519 14.276l-.023 2.478c-.02 2.732-.012 5.463-.004 8.195a2942.174 2942.174 0 0 0-.062 21.844c-.003 5.56-.028 11.122-.051 16.683-.041 10.53-.061 21.058-.074 31.587-.016 11.988-.055 23.976-.095 35.964-.082 24.657-.136 49.315-.172 73.973H91c-.093-26.8-.164-53.599-.207-80.398-.02-12.444-.049-24.888-.095-37.332-.04-10.849-.065-21.697-.074-32.545-.006-5.742-.018-11.484-.047-17.226-.027-5.41-.035-10.82-.03-16.23 0-1.98-.008-3.96-.024-5.941-.1-13.448.46-24.557 9.5-35.328 7.943-8.037 18.253-12.389 29.478-12.58l3.054.006 3.224-.043c3.365-.042 6.73-.057 10.096-.07 3.387-.03 6.774-.064 10.16-.103 2.1-.022 4.198-.038 6.297-.047l2.875-.021 2.519-.01c2.217-.129 4.131-.585 6.274-1.132 1.343.294 2.676.63 4 1 1.705.138 3.415.22 5.125.25l2.633.078L188 137l2-3-5-2c.375-1.938.375-1.938 1-4 2.525-1.262 4.312-1.099 7.125-1.063l2.758.028L198 127l-1-5h5v-5l2-1v-3c3.108.918 5.569 1.658 8.125 3.688 1.783 1.569 1.783 1.569 3.938 1L218 117h3l-2.063-2.688C217 111 217 111 217.25 108.126L218 106c3.633.568 5.184 1.875 7.637 4.563l1.998 2.164 2.053 2.273 2.087 2.273c1.27 1.384 2.536 2.77 3.798 4.16A75.92 75.92 0 0 0 238 124c-.466-3.03-1.326-4.47-3.125-7.063L233 114l1-3h3l1 2 .113-2.738.2-3.575.175-3.55C239 100 239 100 240.328 98.109c2.888-1.916 5.33-1.52 8.672-1.109 2.198 1.606 2.198 1.606 4 4 .454 3.116.454 3.116.39 6.734l-.038 3.926-.102 4.09c-.02 1.379-.038 2.758-.055 4.137A969.067 969.067 0 0 1 253 130c4.83-.08 8.025-.158 11.777-3.398l2.16-2.977 2.215-2.96c3.345-4.754 3.345-4.754 4.167-10.32l.06-2.85.035-3.07.059-3.148c.06-3.321.106-6.643.152-9.965l.117-6.751c.096-5.52.181-11.04.258-16.561l-2.187.016c-3.25.02-6.5.034-9.75.046l-3.444.026-3.271.01-3.031.016C250 68 250 68 249 67V52Z"
    />
    <path
      fill={running ? '#2699e6' : '#788BA1'}
      d="M218 106c3.442.576 4.996 1.658 7.348 4.203l1.834 1.973 1.88 2.074 1.893 2.027c6.23 6.769 8.502 10.935 8.338 20.18l-.013 2.736c-.017 2.874-.054 5.746-.093 8.62a4118.5 4118.5 0 0 0-.04 5.857c-.034 4.777-.085 9.553-.147 14.33h-15v-3l-1 5-3.618-.04a6058.69 6058.69 0 0 0-33.725-.27c-5.78-.032-11.56-.075-17.34-.143-5.576-.065-11.151-.1-16.728-.116a640.26 640.26 0 0 1-6.387-.065c-2.98-.044-5.956-.05-8.935-.047l-2.677-.066-2.464.025-2.135-.016c-3.428 1.27-4.37 3.566-5.991 6.738-.382 2.89-.549 5.394-.519 8.276l-.023 2.478c-.02 2.732-.012 5.463-.004 8.195a2942.174 2942.174 0 0 0-.062 21.844c-.003 5.56-.028 11.122-.051 16.683-.041 10.53-.061 21.058-.074 31.587-.016 11.988-.055 23.976-.095 35.964-.082 24.657-.136 49.315-.172 73.973H91c-.093-26.8-.164-53.599-.207-80.398-.02-12.444-.049-24.888-.095-37.332-.04-10.849-.065-21.697-.074-32.545-.006-5.742-.018-11.484-.047-17.226-.027-5.41-.035-10.82-.03-16.23 0-1.98-.008-3.96-.024-5.941-.1-13.448.46-24.557 9.5-35.328 7.943-8.037 18.253-12.389 29.478-12.58l3.054.006 3.224-.043c3.365-.042 6.73-.057 10.096-.07 3.387-.03 6.774-.064 10.16-.103 2.1-.022 4.198-.038 6.297-.047l2.875-.021 2.519-.01c2.217-.129 4.131-.585 6.274-1.132 1.343.294 2.676.63 4 1 1.705.138 3.415.22 5.125.25l2.633.078L188 137l2-3-5-2c.375-1.938.375-1.938 1-4 2.525-1.262 4.312-1.099 7.125-1.063l2.758.028L198 127l-1-5h5v-5l2-1v-3c3.108.918 5.569 1.658 8.125 3.688 1.783 1.569 1.783 1.569 3.938 1L218 117h3l-2.063-2.688C217 111 217 111 217.25 108.126L218 106Z"
    />
    <path
      fill="#8A9CB3"
      d="M249 52h89v16h-29v26h13l-1 92h25v1h-24c.04 4.892.04 4.892.09 9.783.007 1.74-.04 3.478-.09 5.217l-1 1h-12v27h12c1 1 1 1 1.098 3.285l-.036 2.778-.027 2.785L322 241c-7.806.023-15.611.04-23.417.052-3.624.005-7.249.012-10.873.023-3.495.011-6.99.017-10.484.02-1.988.003-3.977.01-5.965.018h-3.64l-3.223.007C262 241 262 241 261 240c-.098-1.497-.13-3-.125-4.5l-.008-2.469C261 231 261 231 262 230c2.02-.072 4.042-.084 6.063-.063l3.347.028L274 230c.13-6.135.186-12.265.177-18.402.007-2.08.033-4.16.08-6.24.232-10.836.273-20.196-6.269-29.26l-1.344-1.87c-2.876-3.436-5.038-4.59-9.518-5.11A90.057 90.057 0 0 0 253 169l.048 2.599c.05 3.19.088 6.38.117 9.571.015 1.38.035 2.759.061 4.138.037 1.986.052 3.972.067 5.958l.048 3.618c-.37 3.387-.963 4.727-3.341 7.116-2.375.938-2.375.938-5 1-2.283-1.142-4.19-2.19-6-4-.088-2.219-.107-4.44-.098-6.66l.005-2.014c.005-2.13.018-4.259.03-6.388.006-1.441.01-2.882.014-4.323.01-3.538.03-7.077.049-10.615h-17l1-4h3l-1 2 14 1c-.094-5.766-.2-11.532-.317-17.297-.039-1.962-.074-3.923-.105-5.884-.046-2.82-.104-5.64-.164-8.46l-.035-2.655-.06-2.486-.04-2.18c-.32-2.34-1.125-3.993-2.279-6.038l2 1c-.466-3.03-1.326-4.47-3.125-7.063L233 114l1-3h3l1 2 .113-2.738.2-3.575.175-3.55C239 100 239 100 240.328 98.109c2.888-1.916 5.33-1.52 8.672-1.109 2.198 1.606 2.198 1.606 4 4 .454 3.116.454 3.116.39 6.734l-.038 3.926-.102 4.09c-.02 1.379-.038 2.758-.055 4.137A969.067 969.067 0 0 1 253 130c4.83-.08 8.025-.158 11.777-3.398l2.16-2.977 2.215-2.96c3.345-4.754 3.345-4.754 4.167-10.32l.06-2.85.035-3.07.059-3.148c.06-3.321.106-6.643.152-9.965l.117-6.751c.096-5.52.181-11.04.258-16.561l-2.187.016c-3.25.02-6.5.034-9.75.046l-3.444.026-3.271.01-3.031.016C250 68 250 68 249 67V52Z"
    />
    <path
      fill="#93A8C3"
      d="M375 67h62v27l8.454-.063c9.248-.067 18.496-.111 27.744-.144 5.604-.021 11.207-.05 16.811-.095 5.414-.043 10.828-.067 16.242-.078 2.06-.007 4.119-.021 6.178-.043 20.72-.21 20.72-.21 29.571 4.423 1.603 11.224 1 22.662 1 34l57 1v33l-57 1v25c-6.07 7.441-9.489 10.59-18.812 11.81-5.21.392-10.353.157-15.563-.123-1.815-.055-3.63-.105-5.445-.15A533.86 533.86 0 0 1 490 203v-1h8V95h-62v15h-60c-.954-14.305-1-28.663-1-43Z"
    />
    <path
      fill="#9AADC3"
      d="M375 67h62c0 14.337-.106 28.69-1 43h-60c-.954-14.305-1-28.663-1-43Z"
    />
    <path fill="#50677C" d="M321 110h25v76h-25v-76Z" />
    <path
      fill="#8EA4B8"
      d="M249 52h89v16h-29l-1 3v-3h-32l-1 47h-1V68c-7.853.04-7.853.04-15.707.09l-2.945.008-3.031.016C250 68 250 68 249 67V52Z"
    />
    <path fill="#7D91A6" d="M308 95h13v91h25v1h-24v15h-14V95Z" />
    <path
      fill="#798CA3"
      d="M274 117h1v68c-4.2-1.4-5.76-4.443-8.188-7.938l-1.404-1.958C262 170.27 262 170.27 262 168h-9v-38l9-1c2.104-1.626 2.104-1.626 3.25-3.875 2.213-3.445 3.987-5.297 7.75-7.125l1-1Z"
    />
    <path
      fill="#4DA4D8"
      d="M218 106c3.442.576 4.996 1.658 7.348 4.203l1.834 1.973 1.88 2.074 1.893 2.027c5.48 5.953 8.469 9.615 8.232 18.035l-.082 3.801L239 141c-5.384-1.746-10.62-3.791-15.879-5.879A45.14 45.14 0 0 0 215 133l-1 3-1.5-.5c-6.81-1.362-11.419-.54-17.5 2.5l5 1v2c-1.75 1.29-1.75 1.29-4 2.625l-2.25 1.352L192 146l1-4h2v-2l-7 2c.875-5.75.875-5.75 2-8l-5-2c.375-1.938.375-1.938 1-4 2.525-1.262 4.312-1.099 7.125-1.063l2.758.028L198 127l-1-5h5v-5l2-1v-3c3.108.918 5.569 1.658 8.125 3.688 1.783 1.569 1.783 1.569 3.938 1L218 117h3l-2.063-2.688C217 111 217 111 217.25 108.126L218 106Z"
    />
    <path
      fill="#6CC7EA"
      d="M215 133c6.166.493 10.919 1.953 16.5 4.563l2.203.998c1.77.803 3.534 1.62 5.297 2.439v13l-4.164-.14c-1.82-.038-3.64-.075-5.461-.11l-2.738-.102c-5.768-.084-9.076.457-13.637 4.352l-2.188 2.25C209 162 209 162 206 162v-4c-3.122 1.309-3.122 1.309-5 4h-2l-1-5c-4.256-1.16-7.684-.762-12 0 2.232-4.463 4.824-6.367 9-9l1-2-3-1c4.75-4 4.75-4 7-4v-2h-6c2.795-3.236 5.649-4.813 9.96-5.156 3.472-.052 6.732.053 10.04 1.156l1-2Z"
    />
    <path fill="#64A1B7" d="M542 133h58v13h-58v-13Z" />
    <path fill="#51697D" d="M469 202h21v34h-22l1-34Z" />
    <path fill="#65A1B6" d="M542 153h58v12h-58v-12Z" />
    <path
      fill="#91A6BA"
      d="M274 186h1v45h33l1-4v3l2.59-.035 3.348-.028 3.34-.035C321 230 321 230 322 231c.072 1.686.084 3.375.063 5.063l-.028 2.785L322 241c-7.806.023-15.611.04-23.417.052-3.624.005-7.249.012-10.873.023-3.495.011-6.99.017-10.484.02-1.988.003-3.977.01-5.965.018h-3.64l-3.223.007C262 241 262 241 261 240c-.098-1.497-.13-3-.125-4.5l-.008-2.469C261 231 261 231 262 230h12v-44Z"
    />
    <path fill="#576D82" d="M372 181h94v6h-94v-6ZM372 138h94v6h-94v-6Z" />
    <path
      fill="#566C81"
      d="M372 170a35982.3 35982.3 0 0 1 36.325-.052c5.622-.005 11.244-.012 16.866-.023 5.42-.011 10.84-.017 16.261-.02 2.073-.002 4.146-.005 6.219-.01 2.893-.008 5.786-.009 8.678-.009l2.625-.01c5.912.01 5.912.01 7.026 1.124v5h-94v-6Z"
    />
    <path
      fill="#576D82"
      d="M372 149h94v6c-12.108.023-24.217.04-36.325.052-5.622.005-11.244.012-16.866.023-5.42.011-10.84.017-16.261.02-2.073.002-4.146.005-6.219.01-2.893.008-5.786.009-8.678.009l-2.625.01c-5.912-.01-5.912-.01-7.026-1.124v-5ZM379.026 126.876l2.625.01h2.749c3.014 0 6.028.009 9.041.016l6.251.005c5.496.003 10.992.013 16.488.024 5.603.01 11.207.015 16.81.02 11.004.01 22.007.028 33.01.049v6h-94c0-7.03.618-6.113 7.026-6.124ZM379.026 116.876l2.625.01h2.749c3.014 0 6.028.009 9.041.016l6.251.005c5.496.003 10.992.013 16.488.024 5.603.01 11.207.015 16.81.02 11.004.01 22.007.028 33.01.049v6h-93l-1-5c1.867-1.867 4.543-1.12 7.026-1.124Z"
    />
    <path fill="#546A7F" d="M372 192h94v5h-94v-5Z" />
    <path fill="#556B80" d="M372 160h94v5h-94v-5Z" />
    <path
      fill="#C7D1DC"
      d="M412 79c3.57 1.933 5.695 4.084 7 8 .401 4.252.264 6.5-1.75 10.313-3.184 3.803-4.721 4.517-9.625 5.062-4.318-.447-6.318-1.607-9.625-4.375-2.586-3.41-2.365-6.839-2-11 3.325-7.315 8.232-9.465 16-8Z"
    />
    <path fill="#78B8CD" d="M542 146h58v7h-58v-7Z" />
    <path fill="#6796B0" d="M542 140h58v6h-58v-6Z" />
    <path
      fill={running ? '#2699e6' : '#6896B0'}
      d="M542 153h58v5c-3.078 1.026-5.166 1.12-8.39 1.114h-3.336l-3.598-.016-3.687-.005c-3.892-.005-7.784-.018-11.677-.03-2.636-.006-5.272-.01-7.908-.014-6.468-.011-12.936-.028-19.404-.049v-6Z"
    />
    <path fill="#50677B" d="M253 130h9v38h-9v-38Z" />
    <path
      fill="#468CC6"
      d="M218 106c3.442.576 4.996 1.658 7.348 4.203l1.834 1.973 1.88 2.074 1.893 2.027c7.942 8.629 7.942 8.629 8.232 14.535L239 134c-4.118-.622-7.358-1.992-11.063-3.875l-3.097-1.555c-2.489-1.376-4.704-2.695-6.84-4.57v-2h-2l1-4h5l-1.129-1.355c-3.912-5-3.912-5-3.684-8.582L218 106Z"
    />
    <path
      fill="#73869C"
      d="M406.938 84.75C410 85 410 85 413 87c.404 3.163.545 5.14-1.188 7.875-2.467 1.532-3.957 1.553-6.812 1.125-1.813-1.125-1.813-1.125-3-3-.313-3.063-.313-3.063 0-6 2-2 2-2 4.938-2.25Z"
    />
    <path fill="#A9BDCD" d="M190 166h3v2h28v1h-94v-1h63v-2Z" />
    <path
      fill="#86AABE"
      d="M171 136c2.336.314 4.67.65 7 1 1.666.035 3.334.05 5 0v3l-1.953-.223c-7.35-.763-14.552-.833-21.934-.656l-3.585.072c-3.738.076-7.477.16-11.215.244-2.552.054-5.103.107-7.655.159-6.22.128-12.439.263-18.658.404 3.215-2.143 4.115-2.259 7.823-2.303l2.962-.05 3.192-.026 3.275-.051c3.458-.054 6.915-.094 10.373-.132 3.465-.044 6.93-.091 10.394-.143 2.158-.032 4.316-.06 6.474-.08l2.943-.041 2.604-.03c1.963.07 1.963.07 2.96-1.144Z"
    />
    <path
      fill="#89AABE"
      d="M249 97v1l-3.438.938c-3.35.691-3.35.691-4.562 2.062-.158 1.852-.251 3.71-.316 5.566l-.127 3.409-.12 3.588-.13 3.6c-.107 2.945-.209 5.89-.307 8.837h-3v-3l1 1c-.466-3.03-1.326-4.47-3.125-7.063L233 114l1-3h3l1 2 .113-2.738.2-3.575.175-3.55C239 100 239 100 240.313 98.094c2.756-1.787 5.506-1.274 8.687-1.094Z"
    />
    <path fill="#83A9BD" d="m224 164 2 1-1 2 15 1v31h-1v-30h-17c1-4 1-4 2-5Z" />
    <path
      fill="#47A4DB"
      d="M224 153c-5.645 5.802-5.645 5.802-9 8h-2c1.458-5.589 1.458-5.589 3.813-7.375 2.488-.71 4.612-.768 7.187-.625Z"
    />
    <path
      fill="#75A9CA"
      d="M175 132c1.48.114 2.96.241 4.438.375.823.07 1.647.14 2.496.21L184 133l1 2c-2.75.917-4.36 1.109-7.188 1.063L174 136l1-4Z"
    />
    <path
      fill="#81BDD8"
      d="M234 111h3l2 9c-3-1-3-1-4.75-3.375C233 114 233 114 234 111Z"
    />
    <path
      fill="#7EA7BD"
      d="m107 144 2 1-11 11c0-4.16 2.247-6.145 5-9 2.313-1.875 2.313-1.875 4-3Z"
    />
    <path
      fill="#7FB6CF"
      d="m171 136 3.188.5c3.017.396 5.783.592 8.812.5v3a852.64 852.64 0 0 1-4.313-.438c-.8-.08-1.6-.162-2.425-.246C174 139 174 139 171 138v-2Z"
    />
    <path fill="#94BDD2" d="m224 164 2 1-1 2 14 1v1h-17c1-4 1-4 2-5Z" />

    {/* 물 흐름 입자 애니메이션 - running일 때만 보임 */}
    {running && (
      <g>
        {/* 입자 1 */}
        <circle r="5" fill="white" opacity="0.8">
          <animateMotion
            dur="3s"
            repeatCount="indefinite"
            begin="0s"
            keyTimes="0;1"
            values="1;0"
          >
            <mpath href="#waterPath" />
          </animateMotion>
        </circle>

        {/* 입자 2 */}
        <circle r="4.5" fill="white" opacity="0.7">
          <animateMotion
            dur="3s"
            repeatCount="indefinite"
            begin="0.5s"
            keyTimes="0;1"
            values="1;0"
          >
            <mpath href="#waterPath" />
          </animateMotion>
        </circle>

        {/* 입자 3 */}
        <circle r="6" fill="white" opacity="0.6">
          <animateMotion
            dur="3s"
            repeatCount="indefinite"
            begin="1s"
            keyTimes="0;1"
            values="1;0"
          >
            <mpath href="#waterPath" />
          </animateMotion>
        </circle>

        {/* 입자 4 */}
        <circle r="4" fill="white" opacity="0.9">
          <animateMotion
            dur="3s"
            repeatCount="indefinite"
            begin="1.5s"
            keyTimes="0;1"
            values="1;0"
          >
            <mpath href="#waterPath" />
          </animateMotion>
        </circle>

        {/* 입자 5 */}
        <circle r="5.5" fill="white" opacity="0.8">
          <animateMotion
            dur="3s"
            repeatCount="indefinite"
            begin="2s"
            keyTimes="0;1"
            values="1;0"
          >
            <mpath href="#waterPath" />
          </animateMotion>
        </circle>

        {/* 입자 6 */}
        <circle r="2.2" fill="white" opacity="0.7">
          <animateMotion
            dur="3s"
            repeatCount="indefinite"
            begin="2.5s"
            keyTimes="0;1"
            values="1;0"
          >
            <mpath href="#waterPath" />
          </animateMotion>
        </circle>

        {/* 빠른 입자들 (더 자연스러운 효과를 위해) */}
        <circle r="1.6" fill="rgba(255,255,255,0.5)">
          <animateMotion
            dur="2.5s"
            repeatCount="indefinite"
            begin="0.3s"
            keyTimes="0;1"
            values="1;0"
          >
            <mpath href="#waterPath" />
          </animateMotion>
        </circle>

        <circle r="2.6" fill="rgba(255,255,255,0.6)">
          <animateMotion
            dur="2.8s"
            repeatCount="indefinite"
            begin="0.8s"
            keyTimes="0;1"
            values="1;0"
          >
            <mpath href="#waterPath" />
          </animateMotion>
        </circle>

        <circle r="1.8" fill="rgba(255,255,255,0.4)">
          <animateMotion
            dur="3.2s"
            repeatCount="indefinite"
            begin="1.3s"
            keyTimes="0;1"
            values="1;0"
          >
            <mpath href="#waterPath" />
          </animateMotion>
        </circle>

        <circle r="3.2" fill="rgba(255,255,255,0.7)">
          <animateMotion
            dur="2.7s"
            repeatCount="indefinite"
            begin="1.8s"
            keyTimes="0;1"
            values="1;0"
          >
            <mpath href="#waterPath" />
          </animateMotion>
        </circle>
      </g>
    )}
  </svg>
);
